<template>
    <div>
        <public-head title="政策详情"></public-head>
        <div class="main">
        <div class="title">{{lists.name}}</div>
        <div class="content">
              <p v-html="lists.content"></p>
         </div>
   
        </div>
    </div>
</template>

<script>
import PublicHead from "../../../components/publicHead";
import { httpPost } from "../../../axios/index";
export default {
   
    data() {
        return {
            lists:{}
        };
    },
    created() {},
    methods: {
       
        //获取报考政策详情数据
        fetchDetailList(id) {
            httpPost("/classifie/policy_details", {
                id: id
            }).then(res => {
          
                if (res.code === 1) {
                    this.lists = res.list;
                } 
            })
        }
    },
    mounted() {
        this. fetchDetailList(this.$route.query.id);
    },
    components: {
        PublicHead
    }
};
</script>

<style scoped>
    .main{
    width: 100%;
    box-sizing: border-box;
    padding: 0 0.625rem;
    margin-top: 46px;
}
.title{
    font-size: 1.125rem;
    font-weight: bold;
   text-align: center;
}
.content{
    font-size: 0.875rem;
}

</style>